import { Injectable, computed, signal } from '@angular/core';
import { PATIENTS } from '../data/patients.data';
import { Patient } from '../models/patient.model';

@Injectable({ providedIn: 'root' })
export class PatientStateService {
  private readonly _patients = signal<Patient[]>(structuredClone(PATIENTS));
  private readonly _selectedPatientId = signal(PATIENTS[0].id);

  readonly patients = this._patients.asReadonly();

  readonly selectedPatient = computed(
    () => this._patients().find((p) => p.id === this._selectedPatientId()) ?? this._patients()[0]
  );

  selectPatient(id: string): void {
    this._selectedPatientId.set(id);
  }

  updateField<K extends keyof Patient>(patientId: string, key: K, value: Patient[K]): void {
    this._patients.update((list) => list.map((p) => (p.id === patientId ? { ...p, [key]: value } : p)));
  }
}
